// extracted by mini-css-extract-plugin
export default {"root":"Search_root__eiX89","input":"Search_input__klILD","input__cross":"Search_input__cross__ydeUY"};